var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 一单可能有多条：团长一条、收货地代理一条，跨区订单还会多一条「招募代理」。 三者是"
            ),
            _c("b", [_vm._v("不同的人")]),
            _vm._v("，各挂各的代理 ID，所以按角色筛完再看金额才对得上。 "),
            _c("br"),
            _vm._v(
              " 「区域」是订单收货地的行政区划编码，代理分成按它判定，与团长在哪个区无关。 跨区时代理总比例默认按招募代理 30%、收货地代理 70% 拆分，可在联盟配置中调整。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "角色" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.query.role,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "role", $$v)
                        },
                        expression: "query.role",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "团长", value: "LEADER" },
                      }),
                      _c("el-option", {
                        attrs: { label: "收货地代理（区代）", value: "AGENT" },
                      }),
                      _c("el-option", {
                        attrs: { label: "市代", value: "AGENT_CITY" },
                      }),
                      _c("el-option", {
                        attrs: { label: "省代", value: "AGENT_PROVINCE" },
                      }),
                      _c("el-option", {
                        attrs: { label: "招募代理", value: "AGENT_ORIGIN" },
                      }),
                      _c("el-option", {
                        attrs: { label: "直推奖励", value: "DIRECT" },
                      }),
                      _c("el-option", {
                        attrs: { label: "间推奖励", value: "INDIRECT" },
                      }),
                      _c("el-option", {
                        attrs: { label: "团队奖励", value: "TEAM" },
                      }),
                      _c("el-option", {
                        attrs: { label: "区域奖励", value: "REGION_BONUS" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "省市区" } },
                [
                  _c("distribution-region-filter", {
                    model: {
                      value: _vm.query.regionPrefix,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "regionPrefix", $$v)
                      },
                      expression: "query.regionPrefix",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "待结算", value: 0 } }),
                      _c("el-option", { attrs: { label: "结算中", value: 1 } }),
                      _c("el-option", { attrs: { label: "已入账", value: 2 } }),
                      _c("el-option", { attrs: { label: "已失效", value: 3 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "受益人uid" } },
                [
                  _c("el-input", {
                    staticClass: "selWidthSm",
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.query.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "uid", _vm._n($$v))
                      },
                      expression: "query.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "代理ID" } },
                [
                  _c("el-input", {
                    staticClass: "selWidthSm",
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.query.agentId,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "agentId", _vm._n($$v))
                      },
                      expression: "query.agentId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单号" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.query.orderNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "orderNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.orderNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                      "start-placeholder": "开始",
                      "end-placeholder": "结束",
                    },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.loadList(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "150",
                },
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "70" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单号",
                  "min-width": "170",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "角色", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.roleTagType(row.commissionRole),
                            },
                          },
                          [_vm._v(_vm._s(_vm.roleText(row.commissionRole)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "受益人", "min-width": "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        !row.uid
                          ? _c("div", [_vm._v("平台兜底")])
                          : _c("div", [
                              _c("div", [
                                _vm._v(_vm._s(_vm.userName(row.uid))),
                              ]),
                              _c("div", { staticClass: "sub-line" }, [
                                _vm._v("uid " + _vm._s(row.uid)),
                              ]),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "省 / 市 / 区",
                  "min-width": "240",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.distributionRegionLabel(
                              row.regionCode,
                              row.regionName
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "agentId", label: "代理ID", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "计佣基数", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.money(row.orderPrice)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "比例", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.ratioText(row.ratio)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "分成金额", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            class: {
                              "danger-text": Number(row.commissionAmount) < 0,
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.money(row.commissionAmount)) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTagType(row.status),
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(row.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "冲正", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.reversed ? "是" : "-"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ruleVersion",
                  label: "规则版本",
                  "min-width": "130",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "settlementTime",
                  label: "入账时间",
                  "min-width": "150",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pager" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.query.size,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.loadList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }